import { render, staticRenderFns } from "./full-channel-card.vue?vue&type=template&id=62ed43d2&"
import script from "./full-channel-card.vue?vue&type=script&lang=ts&"
export * from "./full-channel-card.vue?vue&type=script&lang=ts&"
import style0 from "./full-channel-card.vue?vue&type=style&index=0&id=62ed43d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports